const firebase = require('firebase/app');
require('firebase/auth');
require('firebase/database');
const _ = require('underscore');
const API = require('common/infra/api/firebase');
const Logger = require('common/util/logger');

const MAX_RETRY = 10;
let signInRetry = 0;

// localhosst の場合 firebaseUserID には prefix 付加されているので分離する
// e.g. "locahost-123dfr:12345"
const getUserID = function(firebaseUserID) {
    if(!firebaseUserID) {
        return null;
    }
    if(firebaseUserID.split(':').length > 1) {
        return firebaseUserID.split(':')[1];
    } else {
        return firebaseUserID;
    }
};

class Firebase {
    initialize(config, user) {
        firebase.initializeApp(config);
        if(!user) {
            return new Promise((resolve, reject) => {
                resolve();
            })
        }

        return new Promise((resolve, reject) => {
            firebase.auth().onAuthStateChanged(fuser => {
                Logger.info(`firebase.auth().onAuthStateChanged; user=${user && user.id}, firebaseUser.uid=${fuser && fuser.uid}`);

                signInRetry ++;
                if(signInRetry > MAX_RETRY) {
                    return;
                }

                if (!fuser) {
                    API.getToken()
                        .then(data => {
                            Logger.info(`firebase.signInWithCustomToken starting...`);
                            this.signInWithCustomToken(data.token)
                                .then(() => {
                                    Logger.info(`firebase.signIn success.`);
                                    resolve();
                                });
                        }, reject);
                    return;
                }

                const uid = getUserID(fuser.uid);
                if(uid != user.id) {
                    firebase.auth().signOut()
                        .then(() => {
                            API.getToken()
                                .then(data => {
                                    Logger.info(`firebase.signInWithCustomToken starting...`);
                                    this.signInWithCustomToken(data.token)
                                        .then(() => {
                                            Logger.info(`firebase.signIn success.`);
                                            resolve();
                                        });
                                });
                        }, reject);
                }
            });
        });
    }

    signOut(config) {
        firebase.initializeApp(config);
        return firebase.auth().signOut();
    }

    signInWithCustomToken(token) {
        return firebase.auth().signInWithCustomToken(token);
    }

    listen(path, callback, options) {
        let ref = firebase.database().ref(path);
        ref.on('value', function (snapshot) {
            callback(snapshot.val());
        });
    }

    listenOrderByKey(path, callback, options) {
        let ref = firebase.database().ref(path).orderByKey();
        if(options.startAt) {
            ref = ref.startAt(options.startAt);
        }
        ref.on('child_added', function (snapshot) {
            callback(snapshot.val());
        });
    }

    update(path, data) {
        let updates = {};
        _.each(data, (v, k)=> {
            updates[`${path}/${k}`] = v;
        });
        firebase.database().ref().update(updates);
    }

    push(path, data) {
        return firebase.database().ref(path).push(data);
    }
}

module.exports = new Firebase();



// WEBPACK FOOTER //
// ./common/infra/firebase/index.js